import '.a{display:flex;}.ssr-plugin'
import '.q{flex-direction:row;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.an{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ee{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.ef{margin-top:2rem;}.ssr-plugin'
import '.a1{margin-bottom:5rem;}.ssr-plugin'
import '.ao{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <div className="a q t"
      >
        <InitiativeSideBar />
        <div className="an a r ab b"
          style={{
            marginLeft: isMobile ? '3.25rem' : '14rem', // left bar
          }}
        >
          <DashboardNavBar
            initiativeDashboard={true}
            style={{ backgroundColor: 'var(--palette-white)' }}
          />
          <div className="ee a b a2 ef a1 ao"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '60%', // 12rem is padding + navbar height
              paddingInline: isMobile ? '1rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
